import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { all_routes } from "../feature-module/router/all_routes";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import { acceptRejectLogHour } from "../core/data/redux/logHour/_logHourAction";

interface RejectLogRequestModalProps {
  show: boolean;
  onHide: () => void;
  data: any
}

const RejectLogRequestModal: React.FC<RejectLogRequestModalProps> = ({ show, onHide, data }) => {
  const routes: any = all_routes;
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const [reason, setReason] = useState("");

  // reset when modal closes
  useEffect(() => {
    if (!show) {
      setReason("");
    }
  }, [show]);

  const handleConfirmLogout = async () => {
    try {
      if (!data) {
        toast.error("No request selected for reject log request");
        return;
      }

      const payload = {
        status: "reject",
        reason: reason.trim() || null,
      };
      const result = await dispatch(acceptRejectLogHour({ uuid: data?.uuid, values: payload }));
      onHide();
    }
    catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.error);
      }
      console.log(error);
    }
  };


  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="reguest-log-hour-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Rejection Reason <small className="text-muted">(Optional)</small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Reason for rejection</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter Reason for rejection"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button
          variant="warning"
          className="px-5 text-white fw-bold log-time-button btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center  btn-block w-100"
          onClick={handleConfirmLogout}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectLogRequestModal;